import { IMaskInput } from "react-imask";
import { FactoryArg, FactoryReturnMasked } from "imask";
import { ComponentProps } from "react";
import { Input, InputProps } from "@chakra-ui/react";
import { Controller, UseControllerProps } from "react-hook-form";
import { mask as maskFn } from "../../util";
import { Masked } from "imask";

type IMaskInputProps = Omit<ComponentProps<typeof IMaskInput>, "mask">;
export type MaskedInputProps<Opts extends FactoryArg> = InputProps & IMaskInputProps & Pick<FactoryReturnMasked<Opts>, "mask">;

export const MaskedInput = <Opts extends FactoryArg>(props: MaskedInputProps<Opts>) => {
    return <Input as={IMaskInput} {...props} />;
};

export type MaskedInputControlledProps<Opts extends FactoryArg> = Omit<MaskedInputProps<Opts>, "name"> & UseControllerProps;
export const MaskedInputControlled = <Opts extends FactoryArg>({ control, name, rules, mask, ...props }: MaskedInputControlledProps<Opts>) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { onChange, value }, fieldState: { isDirty, isTouched } }) => {
                if (!isDirty && !isTouched && value?.length) {
                    /*
                     * In order for this to pass validation, it needs to be formatted as a phone number. This code forces the model to contain the formatted value.
                     * Without this, you will get a validation error when you submit if the value hasn't been touched.
                     * */
                    const formattedValue = maskFn(value, mask as Masked<unknown>);
                    if (formattedValue !== value) {
                        // We can't update state from within a render function, so I'm getting around this by doing it on the next tick
                        setTimeout(() => onChange(formattedValue));
                    }
                }

                return (
                    <MaskedInput
                        onAccept={newValue => {
                            onChange(newValue);
                        }}
                        value={value}
                        mask={mask}
                        {...props}
                    />
                );
            }}
        />
    );
};
